
import React, { useState } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Header } from "@/components/Header";
import { GenderSelection } from "@/components/GenderSelection";
import { CalculatorSelection } from "@/components/CalculatorSelection";
import BasicCalculator from "@/components/BasicCalculator";
import { AdvancedCalculator } from "@/components/AdvancedCalculator";
import { ClimactericCalculator } from "@/components/ClimactericCalculator";
import { MaleSymptoms } from "@/components/MaleSymptoms";
import { AIChatbot } from "@/components/AIChatbot";
import { Footer } from "@/components/Footer";
import { PulsatingLink } from "@/components/PulsatingLink";
import { ExamList } from "@/components/ExamList";
import { HomeButton } from "@/components/HomeButton";

export default function App() {
  const [gender, setGender] = useState(null);
  const [calculatorType, setCalculatorType] = useState(null);
  const [examData, setExamData] = useState(null);
  const [results, setResults] = useState(null);
  const [showExamList, setShowExamList] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);

  const renderContent = () => {
    if (showExamList) {
      return (
        <ExamList
          onBack={() => setShowExamList(false)}
        />
      );
    }

    if (!gender) {
      return (
        <>
          <GenderSelection onSelect={setGender} />
          <PulsatingLink onClick={() => setShowExamList(true)} />
        </>
      );
    }

    if (!calculatorType) {
      return (
        <CalculatorSelection
          gender={gender}
          onSelect={setCalculatorType}
          onBack={() => setGender(null)}
        />
      );
    }

    switch (calculatorType) {
      case "basic":
        return (
          <BasicCalculator
            onBack={() => setCalculatorType(null)}
            gender={gender}
            onResultsUpdate={(results) => {
              setResults(results);
              setExamData(examData);
            }}
          />
        );
      case "advanced":
        return (
          <AdvancedCalculator
            onBack={() => setCalculatorType(null)}
            gender={gender}
            onExamDataUpdate={setExamData}
            onResultsUpdate={setResults}
          />
        );
      case "climacteric":
        return (
          <ClimactericCalculator
            onBack={() => setCalculatorType(null)}
            onExamDataUpdate={setExamData}
            onResultsUpdate={setResults}
          />
        );
      case "symptoms":
        return (
          <MaleSymptoms
            onBack={() => setCalculatorType(null)}
            onResultsUpdate={setResults}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-[#1a1a2e] text-white pb-20">
      <Header />
      <main className="container mx-auto px-4 pt-32">
        {renderContent()}
      </main>
      <HomeButton onClick={() => {
        setGender(null);
        setCalculatorType(null);
        setShowExamList(false);
      }} />
      <AIChatbot 
        examValues={examData}
        isOpen={isChatOpen}
        onOpenChange={setIsChatOpen}
      />
      <div 
        onClick={() => setIsChatOpen(!isChatOpen)}
        className="fixed bottom-6 right-6 z-50 cursor-pointer"
      >
        <div className="w-14 h-14 rounded-full bg-gradient-to-r from-[#ff3366] to-[#ff6b6b] shadow-lg flex items-center justify-center hover:scale-110 transition-transform duration-200">
          <svg 
            className="w-6 h-6 text-white" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" 
            />
          </svg>
        </div>
      </div>
      <Footer />
      <Toaster />
    </div>
  );
}
